<template>
  <div class="m_merchants">
    <mt-header title="展商收藏">
      <span slot="left" @click="()=>this.$router.back()">
        <i class="iconfont icon-left"></i>
        返回
      </span>
    </mt-header>
    <div class="m_content">
      <ul
        v-show="zsList.list.length>0"
        v-infinite-scroll="loadMore"
        infinite-scroll-disabled="moreLoading"
        infinite-scroll-distance="100"
        infinite-scroll-immediate-check="false"
        >
        <li class="liItemL" v-for="item in zsList.list" :key="'A'+item.id" @click="$router.push('/exhibitor/details/'+item.id+'/'+item.ocid)">
          <div class="liLeft">
            <img :src="item.corplogo_cn" alt=""/>
          </div>
          <div class="liRight">
            <h6>{{item.corpname_cn}}</h6>
            <p>展位号：{{item.booth}}</p>
            <p>展位面积：{{item.area}}m²</p>
          </div>
          <div class="quguan">
            取消
          </div>
        </li>
        <li class="more_loading" >
          <span v-show="zsList.list.length<zsList.listnum">
          <!-- <span > -->
            <div class="m_upload">
              <mt-spinner type="snake" color="#00ccff" :size="20" ></mt-spinner>
              <span>加载中</span>
            </div>
          </span>
          <span v-show="zsList.list.length>=zsList.listnum" class="over">我是有底线的！！！</span>
        </li>
      </ul>
      <div v-show="zsList.list.length<=0" class="zanwu">
        <div><img src="https://cippe-1302098519.cos.ap-beijing.myqcloud.com/public/icon/without.png" alt=""/></div>
        <p class="p">暂无信息可查看，快来发布信息发布吧！</p>
      </div>
    </div>
  </div>
</template>

<script>
import { reqExhibitorList } from "../../../../api";
export default {
  data(){
    return{
      zsList:{list:[],listnum:0,pagelistnum:0,thispage:0},
      zsloading:false,
    }
  },
  mounted(){
    this.exhibitorList()
  },
  methods:{
    // 懒加载
    async loadMore() {
      this.exhibitorList(this.zsList.thispage*1+1,false)

    },
    // 展商收藏列表请求
    async exhibitorList(page=1,falg=true){
      this.zsloading = true
      // this.tableData = {list:[],
      //   listnum:0,
      //   pagelistnum:0,
      //   thispage:0}
      const response = await reqExhibitorList(page,this.zsflId,this.name)
      if(response.code==0){
        if (falg) {
          this.zsList={
            list:response.resilt,
            listnum:response.listnum,
            pagelistnum:response.pagelistnum,
            thispage:response.thispage
          }
        }else{
          this.zsList.list.push(...response.resilt)
          this.zsList.thispage=response.thispage
        }
      }else{
        this.zsList={
          list:[],
          listnum:0,
          pagelistnum:0,
          thispage:0
        }
        this.zsloading = false
      }
    },
  }
}
</script>

<style scoped>
.m_merchants{
  height: 100%;
}
.m_content{
    height: calc(100% - 30px);
    overflow-y: auto;
    padding: 0 10px;
}
.liItemL{
  width: 100%;
  height: 100px;
  display: flex;
  /* padding: 10px 0 10px 10px; */
  margin-top: 10px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, .2);
  border-radius: 10px;
  overflow: hidden;
}
.liLeft{
  width: 24%;
  padding: 10px;
}
.liRight{
  padding: 20px 0;
  width: 60%;
  line-height: 20px;
}
.quguan{
  width: 16%;
  background-color: #ff840c;
  color: white;
  font-size: 14px;
  text-align: center;
  line-height: 100px;
}

/* 空 */
.zanwu{
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -70%);
  width: 240px;
  text-align: center;
}
</style>